import { $api } from "@/shared/api";

// Запрос текущего пользователя (`GET /api/me`). Ключ нужен для `setQueryData` после `PATCH /api/me`.
// Заодно бэкенд выдаёт гостю cookie `csrftoken`, без которой не начать вход через Steam.
export const meQueryOptions = () => $api.queryOptions("get", "/api/me");
